module.exports = __webpack_public_path__ + "static/Fluke.48a3254e.png";